import { Separator } from '@radix-ui/react-context-menu'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { cn } from '#src/cn.ts'

export interface ContextMenuSeparatorProps extends ComponentPropsWithoutRef<
  typeof Separator
> {
  asChild?: boolean
  className?: string
}

export const ContextMenuSeparator = forwardRef<
  ElementRef<typeof Separator>,
  ContextMenuSeparatorProps
>(({ className, ...delegated }, ref) => (
  <Separator
    ref={ref}
    className={cn('-mx-1 my-1 h-px bg-border', className)}
    {...delegated}
  />
))
ContextMenuSeparator.displayName = Separator.displayName
